import { useAuthTokenGetter } from "@memorang/ui/contexts/AuthTokenContext";
import axios from "axios";
import { useCallback } from "react";
import { ENDPOINT_RESEND_EMAIL } from "../constants";

type SendEmailParams = {
	text?: string;
	examName?: string;
	toEmail?: string;
	companyName?: string;
};

export const useSendEmail = () => {
	const getAuthToken = useAuthTokenGetter();
	return useCallback(
		// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: error-shaping branches in catch
		async ({ text, examName, toEmail, companyName }: SendEmailParams) => {
			const token = await getAuthToken();
			try {
				await axios.post(
					ENDPOINT_RESEND_EMAIL,
					{
						examName,
						markdown: text,
						toEmail,
						companyName,
					},
					{
						headers: token ? { Authorization: token } : undefined,
					},
				);
			} catch (error) {
				if (axios.isAxiosError(error)) {
					const status = error.response?.status;
					const statusText = error.response?.statusText ?? "";
					const detail =
						typeof error.response?.data === "string"
							? error.response.data.slice(0, 200)
							: "";
					throw new Error(
						`Email send failed [${status} ${statusText}]: ${error.message}${detail ? ` — ${detail}` : ""}`,
						{ cause: error },
					);
				}
				throw new Error("Email send failed with an unexpected error", {
					cause: error,
				});
			}
		},
		[getAuthToken],
	);
};
